import { render, staticRenderFns } from "./monthFixRecord.vue?vue&type=template&id=5bf3066e&scoped=true&"
import script from "./monthFixRecord.vue?vue&type=script&lang=js&"
export * from "./monthFixRecord.vue?vue&type=script&lang=js&"
import style0 from "./monthFixRecord.vue?vue&type=style&index=0&id=5bf3066e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3066e",
  null
  
)

export default component.exports